/**
 * @generated SignedSource<<9ed5c7173506267a74149ee38ff5e797>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddIHKCertificateRewardInput = {
  clientMutationId?: string | null;
  contentId: string;
};
export type createIhkCertificateRewardButton_AddIHKCertificateRewardMutation$variables = {
  input: AddIHKCertificateRewardInput;
};
export type createIhkCertificateRewardButton_AddIHKCertificateRewardMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addIHKCertificateReward: {
        readonly content: {
          readonly " $fragmentSpreads": FragmentRefs<"rewardEditor_TreeNodeFragment">;
        };
      } | null;
    };
  };
};
export type createIhkCertificateRewardButton_AddIHKCertificateRewardMutation = {
  response: createIhkCertificateRewardButton_AddIHKCertificateRewardMutation$data;
  variables: createIhkCertificateRewardButton_AddIHKCertificateRewardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createIhkCertificateRewardButton_AddIHKCertificateRewardMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddIHKCertificateRewardPayload",
                "kind": "LinkedField",
                "name": "addIHKCertificateReward",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "rewardEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createIhkCertificateRewardButton_AddIHKCertificateRewardMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddIHKCertificateRewardPayload",
                "kind": "LinkedField",
                "name": "addIHKCertificateReward",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rewards",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isReward"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ExternalLicenseRewardData",
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ExternalLicensePool",
                                            "kind": "LinkedField",
                                            "name": "pool",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ExternalLicensePoolData",
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "name",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "superId",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ExternalLicenseReward",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bundleIds",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "IHKCertificateBundle",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rewards",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3d6eeb30369008679a7b9225daae0b57",
    "id": null,
    "metadata": {},
    "name": "createIhkCertificateRewardButton_AddIHKCertificateRewardMutation",
    "operationKind": "mutation",
    "text": "mutation createIhkCertificateRewardButton_AddIHKCertificateRewardMutation(\n  $input: AddIHKCertificateRewardInput!\n) {\n  Admin {\n    Tree {\n      addIHKCertificateReward(input: $input) {\n        content {\n          ...rewardEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment createExternalLicenseRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment createIhkCertificateRewardBundleButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment createIhkCertificateRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment externalLicenseRewardForm_ExternalLicenseRewardFragment on ExternalLicenseReward {\n  ... on Reward {\n    __isReward: __typename\n    id\n  }\n  superId\n  data {\n    pool {\n      id\n      data {\n        name\n      }\n    }\n  }\n}\n\nfragment ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment on IHKCertificateBundle {\n  id\n  bundleIds\n}\n\nfragment rewardEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        id\n        kind\n        ... on ExternalLicenseReward {\n          data {\n            pool {\n              data {\n                name\n              }\n              id\n            }\n          }\n        }\n        ...rewardForm_RewardFragment\n      }\n    }\n  }\n  ...rewardForm_TreeNodeFragment\n  ...createExternalLicenseRewardButton_TreeNodeFragment\n  ...createIhkCertificateRewardButton_TreeNodeFragment\n  ...createIhkCertificateRewardBundleButton_TreeNodeFragment\n}\n\nfragment rewardForm_RewardFragment on Reward {\n  __isReward: __typename\n  id\n  kind\n  ... on ExternalLicenseReward {\n    ...externalLicenseRewardForm_ExternalLicenseRewardFragment\n  }\n  ... on IHKCertificateBundle {\n    ...ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment\n  }\n}\n\nfragment rewardForm_TreeNodeFragment on TreeNode {\n  id\n}\n"
  }
};
})();

(node as any).hash = "a0d0492e22fce01d00b7ef14d2e70e76";

export default node;
